import { FormikProps, useFormik } from 'formik';
import { getAddTranslationFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { ITranslation } from '../../../../types/interfaces/translation';
import { FormikValues } from 'formik/dist/types';
import { usePostPutTranslation } from '../../../../services/redux/api/translationsAPI';
import { useGetLanguages } from '../../../../services/redux/api/languagesAPI';

export function useAddTranslationComponent(
  onClose: () => void,
  translation?: ITranslation,
) {
  const { t } = useTranslation();
  const [postPutTranslation, { isLoading }] = usePostPutTranslation();
  const { data: languages } = useGetLanguages();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddTranslationFormValidation(t),
    initialValues: {
      key: translation?.key || '',
      language: translation?.language || null,
      value: translation?.value || '',
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutTranslation({
      id: translation?.id,
      body: {
        key: values.key,
        languageId: values.language?.id,
        value: values.value,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return { formik, isLoading, languages };
}
